export enum AlgorithmAttributesIds {
  ManualParametersHierarchyLevel = 301,
  ConfidenceLevelHierarchyLevel = 303,
  EnergyCostVolumeHierarchyLevel = 401,
  OutOfRangeMapColor = 410,
  AbnormalConsumptionHierarchyLevel = 425,
  PrioritisationHierarchyLevel = 71,
}
